import { handleActions, combineActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/anewstip'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  journalists: []
})

export default handleActions({
  [Actions.setSelectedJournalists]: (state, { payload }) => state.set('journalists', payload),
  [Actions.removeSelectedJournalist]: (state, { payload }) => state.update(
    'journalists',
    oldValue => oldValue.filter(id => id !== payload.get('id'))
  ),
  [combineActions(
    Actions.searchJournalistsStart,
    Actions.clearModuleData
  )]: () => initialState,
  [AppActions.resetState]: () => initialState
}, initialState)
